import MessageFormatter from 'shared/helpers/MessageFormatter';
import { readMentionTargets } from 'dashboard/helper/editorMentionHelper';

export const legacyMentionAttributes = (
  message,
  { expandedRecipients = true } = {}
) => {
  const attributes = message?.content_attributes || {};
  const targets =
    attributes.content_format === 'markdown'
      ? readMentionTargets(message.content)
      : { mentionedUserIds: [], mentionedTeamIds: [], mentionAll: false };
  return {
    // Keep explicit person selections apart from expanded message recipients.
    // Drafts already contain only explicit IDs and need no expansion filtering.
    mentioned_user_ids: (expandedRecipients &&
    (targets.mentionAll || targets.mentionedTeamIds.length)
      ? attributes.explicit_mentioned_user_ids || []
      : attributes.mentioned_user_ids || []
    )
      .filter(id => !targets.mentionedUserIds.includes(Number(id)))
      .map(Number),
    mentioned_team_ids: (attributes.mentioned_team_ids || [])
      .filter(id => !targets.mentionedTeamIds.includes(Number(id)))
      .map(Number),
    mention_all: Boolean(attributes.mention_all) && !targets.mentionAll,
  };
};

export const reconciledMentionAttributes = ({
  content,
  contentFormat,
  members,
  previous,
}) => {
  const targets =
    contentFormat === 'markdown'
      ? readMentionTargets(content)
      : { mentionedUserIds: [], mentionedTeamIds: [], mentionAll: false };
  let text = content;
  if (contentFormat === 'markdown') {
    const formatter = new MessageFormatter(content);
    formatter.disableImageRendering();
    text = formatter.plainText;
  }
  const hasMention = label => {
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`@${escaped}(?=$|[^\\p{L}\\p{N}_])`, 'u').test(text);
  };
  const userIds = new Set(previous.mentioned_user_ids || []);
  const teamIds = new Set(previous.mentioned_team_ids || []);
  return {
    mentionedUserIds: members.users
      .filter(
        ({ user }) =>
          targets.mentionedUserIds.includes(user.id) ||
          (userIds.has(user.id) && hasMention(user.display_name || user.name))
      )
      .map(({ user }) => user.id),
    mentionedTeamIds: members.teams
      .filter(
        ({ team }) =>
          targets.mentionedTeamIds.includes(team.id) ||
          (teamIds.has(team.id) && hasMention(team.name))
      )
      .map(({ team }) => team.id),
    mentionAll:
      targets.mentionAll ||
      (Boolean(previous.mention_all) &&
        /(?:^|\s)@all(?:\s|$|[.,!?])/i.test(text)),
  };
};
